module.exports = __webpack_public_path__ + "img/unionPay.2c7d1c4a.svg";